/** 资源库三语文案分片 · 预览/详情/编辑弹窗（由 strings.ts 聚合） */
export const resPartPreview = {
  // AssetPreviewInfo / AssetFolderDetailDialog：详情字段
  resPreviewDetailInfo: { en: "Details", zh: "详细信息", id: "Detail" },
  resPreviewProductName: { en: "Product name", zh: "商品名称", id: "Nama produk" },
  resPreviewProductBrand: { en: "Product brand", zh: "商品品牌", id: "Merek produk" },
  resPreviewProductCategory: { en: "Product category", zh: "商品类目", id: "Kategori produk" },
  resPreviewProductAudience: { en: "Target audience", zh: "适用人群", id: "Target audiens" },
  resPreviewProductAttachments: { en: "Product attachments", zh: "商品附件", id: "Lampiran produk" },
  resPreviewNoAttachments: { en: "No attachments", zh: "暂无附件", id: "Belum ada lampiran" },
  resPreviewProductImages: { en: "Product images", zh: "商品图片", id: "Gambar produk" },
  resPreviewNoImages: { en: "No images", zh: "暂无图片", id: "Belum ada gambar" },
  resPreviewBroadcastLabel: { en: "Voiceover / narration", zh: "是否有口播/旁白", id: "Sulih suara / narasi" },
  resPreviewFieldLocation: { en: "Location", zh: "位置", id: "Lokasi" },
  resPreviewFieldFormat: { en: "Format", zh: "格式", id: "Format" },
  resPreviewFieldFileSize: { en: "File size", zh: "文件大小", id: "Ukuran file" },
  resPreviewFieldUploader: { en: "Uploaded by", zh: "上传者", id: "Diunggah oleh" },
  resPreviewFieldUploadTime: { en: "Upload time", zh: "上传时间", id: "Waktu unggah" },
  resPreviewFieldCreator: { en: "Created by", zh: "创建者", id: "Dibuat oleh" },
  resPreviewFieldCreateTime: { en: "Created at", zh: "创建时间", id: "Dibuat pada" },
  resPreviewPacking: { en: "Packing...", zh: "打包中...", id: "Mengemas..." },
  resPreviewDownloadDigital: { en: "Download character", zh: "下载数字人", id: "Unduh karakter" },
  resPreviewReportBtn: { en: "Analysis report", zh: "拆解报告", id: "Laporan analisis" },
  resPreviewNo: { en: "No", zh: "否", id: "Tidak" },
  resPreviewAttachmentFallback: { en: "Attachment", zh: "附件", id: "Lampiran" },
  resPreviewProduct: { en: "Product", zh: "商品", id: "Produk" },
  resPreviewImage: { en: "Image", zh: "图片", id: "Gambar" },
  resPreviewImageDescLabel: { en: "Image description", zh: "图片描述", id: "Deskripsi gambar" },
  // AssetRelationBoard：衍生关系画板
  resPreviewRelationSrTitle: { en: "Character details — derivations", zh: "数字人详情 — 衍生关系", id: "Detail karakter — relasi turunan" },
  resPreviewRelationSubtitle: { en: "Base character + {n} derived", zh: "基底数字人 + {n} 个衍生形象", id: "Karakter dasar + {n} turunan" },
  resPreviewRelationListTitle: { en: "Characters", zh: "数字人列表", id: "Daftar karakter" },
  resPreviewBadgeBase: { en: "Base", zh: "基底", id: "Dasar" },
  resPreviewBadgeDerived: { en: "Derived", zh: "衍生", id: "Turunan" },
  resPreviewCanvasHint: {
    en: "Drag to move · Scroll to zoom {n}%",
    zh: "拖拽移动 · 滚轮缩放 {n}%",
    id: "Seret untuk geser · Gulir untuk zoom {n}%",
  },
  resPreviewRelationRendering: {
    en: "Rendering character... About 1 minute~",
    zh: "数字人渲染中，预计耗时约 1 分钟~",
    id: "Merender karakter... sekitar 1 menit~",
  },
  resPreviewLinkInvalid: { en: "Character link unavailable", zh: "数字人链接失效", id: "Tautan karakter tidak valid" },
  resPreviewEditNameTitle: { en: "Edit name", zh: "编辑名称", id: "Edit nama" },
  resPreviewRebindVoiceTitle: { en: "Change voice", zh: "换绑音色", id: "Ganti suara" },
  resPreviewRebindVoice: { en: "Change", zh: "换绑", id: "Ganti" },
  resPreviewRelationTitleWithBase: { en: "{name} · Derivations", zh: "{name} · 衍生关系", id: "{name} · Relasi turunan" },
  resPreviewRelationTitle: { en: "Derivations", zh: "衍生关系", id: "Relasi turunan" },
  resPreviewVoiceDefault: { en: "Default voice", zh: "默认音色", id: "Suara bawaan" },
  resPreviewVoiceBound: { en: "Voice bound", zh: "已绑定音色", id: "Suara terikat" },
  resPreviewVoiceInherited: { en: "Default voice · {detail}", zh: "默认音色 · {detail}", id: "Suara bawaan · {detail}" },
  resPreviewErrNameRequired: { en: "Please enter a name", zh: "请输入名称", id: "Mohon isi nama" },
  resPreviewNameUpdated: {
    en: 'Character name updated to "{name}"',
    zh: "数字人名称已更新为「{name}」",
    id: 'Nama karakter diperbarui menjadi "{name}"',
  },
  resPreviewVoiceRebound: { en: 'Voice rebound to "{name}"', zh: "已重新绑定音色「{name}」", id: 'Suara diganti menjadi "{name}"' },
  // AssetPreviewDialog / AssetPreviewMedia：商品多图与播放器
  resPreviewImgLabelMain: { en: "Main", zh: "主图", id: "Utama" },
  resPreviewImgLabelFront: { en: "Front", zh: "正面", id: "Depan" },
  resPreviewImgLabelDetail: { en: "Detail", zh: "细节", id: "Detail" },
  resPreviewImgLabelScene: { en: "Scene", zh: "场景", id: "Adegan" },
  resPreviewImgFallback: { en: "Image {n}", zh: "图{n}", id: "Gambar {n}" },
  resPreviewPlayPauseAria: { en: "Play or pause", zh: "播放或暂停", id: "Putar atau jeda" },
  // AssetDigitalPreviewFields：数字人详情字段
  resPreviewVoiceUnbound: { en: "No voice bound", zh: "未绑定音色", id: "Belum ada suara" },
  resPreviewRefPhotos: { en: "Reference photos", zh: "参考照片", id: "Foto referensi" },
  resPreviewNotUploaded: { en: "Not uploaded", zh: "未上传", id: "Belum diunggah" },
  resPreviewPhotoSlot1: { en: "Image 1", zh: "图1", id: "Gambar 1" },
  resPreviewPhotoSlot2: { en: "Image 2", zh: "图2", id: "Gambar 2" },
  resPreviewPhotoSlot3: { en: "Image 3", zh: "图3", id: "Gambar 3" },
  resPreviewDigitalHuman: { en: "Character", zh: "数字人", id: "Karakter" },
  // AssetEditDialog / AssetConfirmDialog / AssetDialogFrame
  resPreviewEditDigitalTitle: { en: "Edit character", zh: "编辑数字人", id: "Edit karakter" },
  resPreviewEnterField: { en: "Enter {label}", zh: "请输入{label}", id: "Masukkan {label}" },
  resPreviewErrDigitalNameRequired: { en: "Please enter a character name", zh: "请输入数字人名称", id: "Mohon isi nama karakter" },
  resPreviewConfirmDelete: { en: "Delete", zh: "确定删除", id: "Hapus" },
  // AssetFolderDetailDialog：文件夹详情
  resPreviewFolderDetailTitle: { en: "Folder details", zh: "文件夹详情", id: "Detail folder" },
  resPreviewFolderName: { en: "Folder name", zh: "文件夹名称", id: "Nama folder" },
  resPreviewFolderCountProduct: { en: "Contains products", zh: "包含商品", id: "Berisi produk" },
  resPreviewFolderCountDigital: { en: "Contains characters", zh: "包含数字人", id: "Berisi karakter" },
  resPreviewFolderCountMaterial: { en: "Contains materials", zh: "包含素材", id: "Berisi materi" },
  resPreviewCountItems: { en: "{n} items", zh: "{n} 个", id: "{n} item" },
  resPreviewFolderTotalSize: { en: "Total size", zh: "总大小", id: "Total ukuran" },
  // AssetMediaThumb / AssetMediaCard：卡片与菜单
  resPreviewUploading: { en: "Uploading...", zh: "上传中…", id: "Mengunggah..." },
  resPreviewAnalyzed: { en: "Analyzed", zh: "已拆解", id: "Dianalisis" },
  resPreviewDerivedCount: { en: "{n} derived", zh: "{n} 衍生", id: "{n} turunan" },
  resPreviewCut: { en: "Cut", zh: "剪切", id: "Potong" },
  resPreviewMoveTo: { en: "Move to", zh: "移动到", id: "Pindah ke" },
  resPreviewViewProduct: { en: "View product", zh: "查看商品", id: "Lihat produk" },
  resPreviewViewDigital: { en: "View character", zh: "查看数字人", id: "Lihat karakter" },
  resPreviewViewVideo: { en: "View video", zh: "查看视频", id: "Lihat video" },
  resPreviewPlayAudio: { en: "Play audio", zh: "播放音频", id: "Putar audio" },
  resPreviewPlayVoice: { en: "Play voice", zh: "播放音色", id: "Putar suara" },
  resPreviewViewMaterial: { en: "View material", zh: "查看素材", id: "Lihat materi" },
  // useAssetLibraryProductPersist：商品入库叠层与通知
  resPreviewCreating: { en: "Creating...", zh: "创建中…", id: "Membuat..." },
  resPreviewSaving: { en: "Saving...", zh: "保存中…", id: "Menyimpan..." },
  resPreviewErrCreateTask: {
    en: "Failed to create upload task. Please retry.",
    zh: "创建上传任务失败，请重试",
    id: "Gagal membuat tugas unggah, silakan coba lagi",
  },
  resPreviewNotifyCreatedTitle: { en: "Product created", zh: "商品创建完成", id: "Produk berhasil dibuat" },
  resPreviewNotifyCreatedMsg: {
    en: '"{name}" added to product library',
    zh: "「{name}」已加入商品库",
    id: '"{name}" telah ditambahkan ke pustaka produk',
  },
  resPreviewNotifyUpdatedTitle: { en: "Product updated", zh: "商品已更新", id: "Produk diperbarui" },
  resPreviewNotifyUpdatedMsg: { en: '"{name}" saved successfully', zh: "「{name}」保存成功", id: '"{name}" berhasil disimpan' },
  resPreviewPersistCreateFailed: { en: "Create failed", zh: "创建失败", id: "Gagal membuat" },
  resPreviewPersistSaveFailed: { en: "Save failed", zh: "保存失败", id: "Gagal menyimpan" },
  resPreviewNotifyCreateFailedTitle: { en: "Product creation failed", zh: "商品创建失败", id: "Gagal membuat produk" },
  resPreviewNotifySaveFailedTitle: { en: "Product save failed", zh: "商品保存失败", id: "Gagal menyimpan produk" },
  resPreviewErrDuplicatePersist: {
    en: "This product is being saved. Please wait.",
    zh: "该商品正在保存，请稍候",
    id: "Produk ini sedang disimpan, mohon tunggu",
  },
} as const;
